import Vue from 'vue'
import VueRouter from 'vue-router'

import AppLogin from '../views/AppLogin.vue';
import store from '../store';

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Login',
        component: AppLogin,
        meta: {
            requiresGuest: true
        }
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/AppDashboard.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/settings',
        name: 'Settings',
        component: () => import('../views/AppSettings.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/rules',
        name: 'Rules',
        component: () => import('../views/AppRules.vue'),
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.isLoggedIn) {
            next('/');
        } else {
            next();
        }
    } else if (to.matched.some(record => record.meta.requiresGuest)) {
        if (store.getters.isLoggedIn) {
            next('/dashboard');
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;